/**
 * Executive Department navigation items.
 * Used by App.js for sidebar/rail navigation and permission-based filtering.
 */
const executiveNavigation = [
  {
    path: '/executive/marketing',
    label: 'Marketing',
    isParent: true,
    subItems: [
      { path: '/tutorial', label: 'Tutorials', module: 'executive/marketing' }
    ]
  },
  // { path: '/executive/innovation-planning', label: 'Innovation and Planning Strategies' },
  // { path: '/executive/collaborations', label: 'Collaborations' },
  {
    path: '/executive/legal',
    label: 'Legal Department',
    isParent: true,
    subItems: [
      { path: '/productPolicyManagement', label: 'Product Policies', module: 'executive/legal' },
      { path: '/privacy-policy', label: 'Privacy Policy', module: 'executive/legal' },
      { path: '/terms-of-use', label: 'Terms of Use', module: 'executive/legal' },
      { path: '/refund-return', label: 'Refund & Return', module: 'executive/legal' }
    ]
  }
];

export default executiveNavigation;
